import * as React from "react";
import { forwardRef } from "react";
const SvgNoWarning = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M44.177.003a3.72 3.72 0 0 0-3.112 1.908L.607 74.528c-1.383 2.482.416 5.532 3.258 5.528h43.053c-.297-2.05-.443-3.832-.342-5.684a6.5 6.5 0 0 1-2.251.411 6.515 6.515 0 1 1 0-13.03 6.48 6.48 0 0 1 4.68 2 28.72 28.72 0 0 1 23.572-16.947L47.565 1.911A3.72 3.72 0 0 0 44.177.003m.147 15.052c3.019 0 5.463.898 5.462 3.918V54.12c0 3.02-2.443 3.67-5.462 3.67s-5.47-.65-5.47-3.67V18.973c0-3.02 2.45-3.918 5.47-3.918" />
    <path d="M75.245 50.752A24.624 24.624 0 0 0 50.62 75.376 24.624 24.624 0 0 0 75.245 100a24.624 24.624 0 0 0 24.624-24.624 24.624 24.624 0 0 0-24.624-24.624m-10.342 9.97 10.341 10.342 10.342-10.342 4.312 4.312-10.342 10.342 10.342 10.342-4.312 4.312-10.341-10.342L64.903 90.03l-4.312-4.312 10.342-10.342L60.59 65.034Z" />
  </svg>
);
const ForwardRef = forwardRef(SvgNoWarning);
export default ForwardRef;
